import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '../atom'

const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  border-radius: 4px;
  gap: 8px;
  border: 1px solid #e6e6e6;
`

const Text = styled.div`
  font-size: 14px;
`

const SubText = styled.div`
  font-size: 12px;
  color: #666; // 원하는 색상으로 변경 가능
`

interface IList {
  label: string
  subText?: string // subText 프로퍼티 추가
  seletedValue?: string
}

interface Props {
  list?: IList[]
  onChange?: (selectedValue: string) => void
  value?: any
}

const ColumnRadioWtihSub = (props: Props) => {
  const { list, onChange, value } = props
  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    if (value) setSelectedValue(value)
  }, [value])

  const handleRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    // 변경된 값(selectedValue)을 부모 컴포넌트로 전달
    if (onChange) {
      onChange(newValue)
    }
  }

  const controlProps = (item: string) => ({
    checked: selectedValue === item,
    onChange: handleRadioButton,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  })

  return (
    <Wrapper>
      <FormControl>
        <RadioGroup value={selectedValue} onChange={handleRadioButton}>
          {list?.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Radio
                  {...controlProps(`${index}`)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#57C9A7',
                    },
                  }}
                  size="small"
                />
              }
              label={
                <>
                  <Text>{item.label}</Text>
                  {item.subText && <SubText>{item.subText}</SubText>}
                </>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Wrapper>
  )
}

export default ColumnRadioWtihSub
